import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { getDepartments } from 'actions/department.action'
import { RootState } from 'reducers/rootReducer'
import { TranslationKeys } from 'types/TranslationKeys'

export interface DepartmentsListProps {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useDepartmentsList = (props: DepartmentsListProps) => {
  const dispatch = useAppDispatch()

  const departments = useSelector(
    (state: RootState) => state.department.departmentsData
  )

  useEffect(() => {
    if (!departments) dispatch(getDepartments())
  }, [departments])

  return {
    ...props,
    departments,
  }
}
